module.exports = __webpack_public_path__ + "img/sup_withdraw_crypto1.2c15760e.jpg";